<template src="./index.html"/>
<style
  src="../../stylus/main.css"
  lang="css">
</style>
<script>

  export default {
    name: 'PrvTreeView',
    props: {
      treeData: {
        type: Object,
        default: () => {}
      },
      selectItem: {
        type: Function,
        default: () => null
      },
    },
    data () {
      return {
        isOpen: true,
      };
    },
    computed: {
      isFolder () { 
        return this.filteredTreeData.children;
      },
      filteredTreeData () {

        return this.renameKeys(this.treeData);
      }
    },
    methods: {
      toggle () {
        if (this.isFolder) {
          this.isOpen = !this.isOpen;
        }
      },
      renameKeys(obj) {
        var entries = Object.entries(obj);
        var nuevoArreglo = entries.map(entry => entry[0] + ': ' + entry[1]);
        return nuevoArreglo;
      },
    }
  };
</script>
